import { combineReducers } from 'redux';
import appUserReducer from './appUserReducer';
import commonReducer from './commonReducer';
import headerReducer from './headerReducer';
import pwReplayer from './pokerwatchPlayer';
import rangeBarReducer from './rangeBarReducer';
import multipleReportCardsReducer from './multipleReportCardsReducer';
import userFormInitialValues from './userFormInitialValuesReducer';
import handHistoryReducer from './handHistoryReducer';
import { reducer as formReducer } from 'redux-form'

// export default combineReducers({
//     appUser: appUserReducer,
//     header: headerReducer,
//     form: formReducer,
//     commonReducer:commonReducer,
//     multipleReportCards: multipleReportCardsReducer
// })

const rootReducer = combineReducers({
    appUser: appUserReducer,
    header: headerReducer,
    pwReplayer:pwReplayer,
    form: formReducer,
    commonReducer:commonReducer,
    multipleReportCards: multipleReportCardsReducer,
    userFormInitialValues: userFormInitialValues,
    rangeBarValue:rangeBarReducer,
    handHistory:handHistoryReducer
});


export default (state, action) => (
    action.type === 'USER_LOGOUT'
        ? rootReducer(undefined, action)
        : rootReducer(state, action)
)



/** WEBPACK FOOTER **
 ** ./src/store/reducer/rootReducer.js
 **/